The additional `WebhookSubscription`-specific criteria to filter by.
